export default __webpack_public_path__ + "static/media/service3.914ae48c.png";